import * as React from "react";

import {
  usePlpPresenterForTheFilterMenu_Mobile,
  useProductListState,
  usePlpPresenterForTheSortingMenu,
} from "../providers";

export const MobileActionBar: React.FunctionComponent = () => {
  const { selectedOptions, selectedSortingOption } = useProductListState();
  const { handleShowTheFilterMenu_onMobile } =
    usePlpPresenterForTheFilterMenu_Mobile();
  const { handleShowTheSortingMenu_onMobile } = usePlpPresenterForTheSortingMenu();

  return (
    <div className="mobile-action-bar">
      <button className="action sort" onClick={handleShowTheSortingMenu_onMobile}>
        <p>{selectedSortingOption.label}</p>
      </button>
      <div className="divider" />
      <button
        className={`action filter ${
          selectedOptions.length > 0 ? "active" : ""
        }`}
        onClick={handleShowTheFilterMenu_onMobile}
      >
        <p>Filter</p>
        {selectedOptions.length > 0 ? (
          <div className="count">{selectedOptions.length}</div>
        ) : null}
      </button>
    </div>
  );
};
